import React, {useEffect} from "react";
import './AnalizaMain.css';
import {useHistory} from "react-router-dom";
import * as BiIcons from "react-icons/bi";
import TeX from '@matejmazur/react-katex';
import MathJax from 'react-mathjax-preview';

export default function Relacje(){

    useEffect(()=>{
        document.title="Relacje";
    },[])

    const { push } = useHistory();

    const comeBackFunc=()=>{
        push('/analiza/pojecia-wstepne');
    }

    return (
        <div className='conceptsContainer'>
            <div className='comeBackDiv' onClick={comeBackFunc}>
                <BiIcons.BiArrowBack/>
                <div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
            </div>

            <h2>Relacje (dwuargumentowe)</h2>
            <p>A i B oznaczają pewne zbiory.</p>
            <p>Iloczyn kartezjański (A x B) jest zbiorem wszystkich par (<TeX math={'a,b'}/>), gdzie <TeX math={'a'}/>&#8712;A,
                <TeX math={'b'}/>&#8712;B</p>
            <p>Możemy go zapisać w następujący sposób:</p>
            <p> A x B = &#123;<TeX math={'a,b'}/> : <TeX math={'a'}/>&#8712;A, <TeX math={'b'}/>&#8712;B&#125;</p>
            <br/>
            <p>Wynikiem iloczynu kartezjańskiego (A x A) będzie natomiast zbiór par (<TeX math={'a'}/>&#39;, <TeX math={'a'}/>&#39;&#39;), gdzie
                <TeX math={'a'}/>&#39;&#8712;A, <TeX math={'a'}/>&#39;&#39;&#8712;A, możemy to również zapisać:
                <TeX math={'a'}/>&#39; A <TeX math={'a'}/>&#39;&#39;.</p>

            <br/><br/><br/>

            <h2>Relacja przechodnia</h2>
            <p>Nazywamy tak relacje R w zbiorze A, gdy zachodzi implikacja:</p>
            <p>R - oznacza dowolny podzbiór iloczynu kartezjańskiego (A x A),</p>
            <p><TeX math={'a,b,c'}/> - oznaczają dowolne podzbiory pewnego zbioru X,</p>
            <p>A - oznacza rodzinę wszystkich pozbiorów X.</p>
            <p className='oneLine'>
                <div><MathJax math={'`bigwedge_(a&#8712;A)`'}/></div>&nbsp;
                <div><MathJax math={'`bigwedge_(b&#8712;A)`'}/></div>&nbsp;
                <div><MathJax math={'`bigwedge_(c&#8712;A)`'}/></div>&nbsp;
                ((<TeX math={'a R b'}/>)&#8743;(<TeX math={'b R c'}/>))&#8658;(<TeX math={'a R c'}/>).
            </p>
            <p>Oznacza to, że jeśli ta relacja zachodzi dla pary (<TeX math={'a,b'}/>) oraz dla pary (<TeX math={'b,c'}/>) to
                będzie zachodzić również dla pary (<TeX math={'a,c'}/>).</p>

            <br/><br/><br/>

            <h2>Relacja zwrotna</h2>
            <p>Nazywamy tak relacje R w zbiorze A, gdy zachodzi implikacja:</p>
            <p className='oneLine'>
                <div><MathJax math={'`bigwedge_(a&#8712;A)`'}/></div>&nbsp;
                <TeX math={'a R a'}/>.
            </p>
            <p>Oznacza to, że każdy element zbioru jest w relacji sam z sobą.</p>

            <br/><br/><br/>

            <h3>Relacja symetryczna</h3>
            <p>Nazywamy tak relacje R w zbiorze A, gdy zachodzi implikacja:</p>
            <p className='oneLine'>
                <div><MathJax math={'`bigwedge_(a&#8712;A)`'}/></div>&nbsp;
                <div><MathJax math={'`bigwedge_(b&#8712;A)`'}/></div>&nbsp;
                (a R b)&#8658;(b R a).
            </p>
            <p>Oznacza to, że jeśli zachodzi dla pary (<TeX math={'a,b'}/>) to będzie zachodziła również dla pary (<TeX math={'b,a'}/>)</p>

            <br/><br/><br/>

            <h3>Relacja antysymetryczna</h3>
            <p>Nazywamy tak relacje R w zbiorze A, gdy zachodzi implikacja:</p>
            <p className='oneLine'>
                <div><MathJax math={'`bigwedge_(a&#8712;A)`'}/></div>&nbsp;
                <div><MathJax math={'`bigwedge_(b&#8712;A)`'}/></div>&nbsp;
                ((<TeX math={'a R b'}/>)&#8743;(<TeX math={'b R a'}/>))&#8658;(<TeX math={'a=b'}/>).
            </p>
            <p>Oznacza to, że dla każdych dwóch elementów ze zbioru, na którym określono tą relację, to jeśli elementy pozostają
            stale w tej relacji bez względu na kolejność, to będą one identyczne.</p>
            <br/><br/><br/>

            <p>Zbiór A jest częściowo uporządkowany ze względu na relację R, jeśli relacja R w zbiorze A jest zwrotna, przechodnia
            oraz antysymetryczna.</p>

            <br/>

            <p>Zbiór A jest liniowo uporządkowany ze względu na relację R, jeśli relacja R w zbiorze A jest zwrotna, przechodnia
                ,antysymetryczna i zachodzi warunek:</p>

            <p className='oneLine'>
                <div><MathJax math={'`bigwedge_(a&#8712;A)`'}/></div>&nbsp;
                <div><MathJax math={'`bigwedge_(b&#8712;A)`'}/></div>&nbsp;
                (a R b)&#8744;(b R a).
            </p>
            <br/>
            <p>Przykładem może być zbiór liczb reczywistych, ponieważ jest on liniowo uporządkowany ze względu na relację &#8804;,
            relacja ta jest zwrotna, przechodnia, antysymetryczna i jeżeli mamy dane dwie liczby rzeczywiste to na pewno jedna z nich
            jest mniejsza lub równa drugiej.</p>
        </div>
    );
}